import { default as BigNumber } from "bignumber.js";
import { bnOrZero, Button, cn, fNumber } from "kz-ui-sdk";
import { useCallback, useMemo } from "react";
import { MIN_DEPOSIT_AMOUNT } from "../StepAmountSelection/StepAmountSelection";

function multiplyAmountFormula(number: number): number[] {
  const preProcessedNum = Math.round(number);
  const roundToNearest = (x: number, multiplier = 1): number => {
    // Round UP the nearest 100 && 1000
    const nearestHundred = Math.ceil((x * multiplier) / 100) * 100;
    const nearestThousand = Math.ceil((x * multiplier) / 1000) * 1000;
    if (x <= 645) {
      return nearestHundred;
    } else {
      return nearestThousand;
    }
  };
  const quickSelect1 = number;
  const quickSelect2 = roundToNearest(preProcessedNum, 1.25);
  const quickSelect3 = roundToNearest(preProcessedNum, 2.1);
  const quickSelect4 = roundToNearest(preProcessedNum, 3.1);
  return [quickSelect1, quickSelect2, quickSelect3, quickSelect4];
}

interface DepositAmountRangeProps {
  onClick: (v: number) => void;
  min: BigNumber | null;
  latestDepositAmount?: number;
}

export const DepositAmountRange = ({ latestDepositAmount, min, onClick }: DepositAmountRangeProps) => {
  const amount = useMemo(() => {
    const minDepositSettingAmount = bnOrZero(min).toNumber();
    if (latestDepositAmount == 0) {
      return Math.max(minDepositSettingAmount, MIN_DEPOSIT_AMOUNT);
    }
    if (latestDepositAmount && latestDepositAmount <= MIN_DEPOSIT_AMOUNT) {
      return Math.max(minDepositSettingAmount, MIN_DEPOSIT_AMOUNT);
    }
    if (latestDepositAmount && latestDepositAmount > MIN_DEPOSIT_AMOUNT) {
      return Math.max(minDepositSettingAmount, latestDepositAmount);
    }
  }, [latestDepositAmount, min]);

  const handleClick = useCallback(
    (v: number) => {
      onClick(v);
    },
    [onClick],
  );

  const displayDepositShortcut: number[] = useMemo(() => {
    return amount ? multiplyAmountFormula(amount) : [];
  }, [amount]);

  return (
    <div className={cn("mt-[5px] flex min-h-[56px] w-full flex-row gap-1.5 text-sm")}>
      {displayDepositShortcut.map((option) => (
        <Button
          key={option}
          onClick={() => handleClick(option)}
          variant="secondary"
          classes={{
            "label&": "text-sm font-normal",
          }}
        >
          {fNumber(option)}
        </Button>
      ))}
    </div>
  );
};
